export const documentRoutes = [
  {
    path: '/payrollsConfig/:id/documentGroups',
    name: 'documentGroups',
    component: () => import('./views/DocumentGroups.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/documentGroups/add',
    name: 'createDocumentGroup',
    component: () => import('./views/CreateDocumentGroup.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/documentGroups/detail/:documentGroupId',
    name: 'documentGroupDetail',
    component: () => import('./views/DocumentGroupDetail.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['admin', 'superadmin'],
    },
  },
]
